package link.erpango.quip

import link.erpango.quip.core.SharedFactory
import link.erpango.quip.core.auth.entities.GoogleAuthCredentials
import link.erpango.quip.core.auth.google.GoogleAuthProvider
import link.erpango.quip.core.auth.google.GoogleAuthProviderImpl
import link.erpango.quip.platform.services.NotificationService

class AppComponents(
    val factory: SharedFactory,
    val notifications: NotificationService,
    val googleAuthProvider: GoogleAuthProvider
)

// Read from window.env injected at runtime
val GOOGLE_WEB_CLIENT_ID: String
    get() {
        val env = js("window.env")
        if (env == undefined || env == null) {
            console.error("CRITICAL: window.env is NOT defined in index.html. Defaulting to empty string.")
            return ""
        }
        val clientId = env.GOOGLE_WEB_CLIENT_ID
        if (clientId == undefined || clientId == null) {
            console.warn("WARNING: window.env.GOOGLE_WEB_CLIENT_ID is undefined. Check entrypoint.sh or index.html.")
            return ""
        }
        return clientId as String
    }
